import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
import BottomBar from "../BottomBar/BottomBar";
class PrivacyPolicy extends Component {
  render() {
    return (
   
        <div id='terms' className="main">
          <Helmet>
            <title>Privacy Policy | MoneyMonk</title>
            <meta name="description" content="Learn how MoneyMonk collects, uses, and protects your personal information on our digital lending platform." />
            <link rel="canonical" href="https://moneymonkapp.in/privacypolicy" />
          </Helmet>
          <Navbar imageData={logo} />
          <PrivacyPolicyContent />
          <BottomBar />
        </div>

    );
  }
}

export default PrivacyPolicy;
